import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { App } from './App.js';
import { AuthProvider } from './api.js';
import { Toaster } from './components/Toast.js';
import './index.css';
import { installApiErrorToasts } from './lib/apiErrorToast.js';

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('Root element not found');

// Surface API failures (403/429/5xx + network) as toasts so an action can never
// fail silently (e.g. a read-only support session blocking a mutation).
installApiErrorToasts(import.meta.env.VITE_API_BASE_URL ?? 'http://localhost:8787/v1');

createRoot(rootEl).render(
  <StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <App />
        <Toaster />
      </AuthProvider>
    </BrowserRouter>
  </StrictMode>,
);
